/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://fnt3n82d83.execute-api.ap-southeast-1.amazonaws.com/prd",
            "region": "ap-southeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ff6c4gobvrfrnbdhrlft33glim.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-southeast-1:0c1dd0b4-84fe-48ae-beff-43bb72d282f6",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_es9mG0a2F",
    "aws_user_pools_web_client_id": "5nmtpe7fms0vvqih3elrk3tmu1",
    "oauth": {
        "domain": "productlibrary-prd.auth.ap-southeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://productlibrary.neo-corporate.com/",
        "redirectSignOut": "https://productlibrary.neo-corporate.com/signout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "productlibrary-20230301091435-hostingbucket-prd",
    "aws_content_delivery_bucket_region": "ap-southeast-1",
    "aws_content_delivery_url": "https://dsb7rr59av069.cloudfront.net",
    "aws_user_files_s3_bucket": "productlibrary8ac91bc9c8fd43c98fa647f982192d1f150717-prd",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
